/* Aquishop - calculateurs de fiche produit (dose, dimensionnement, bâche) */
(function () {
  'use strict';
  var LOCALE = document.documentElement.lang || 'fr';
  function num(v) { v = String(v || '').replace(',', '.').trim(); var n = parseFloat(v); return isFinite(n) && n > 0 ? n : 0; }
  function fmt(n, d) { return n.toLocaleString(LOCALE, { maximumFractionDigits: d === undefined ? 1 : d }); }
  function eur(c) { return (c / 100).toLocaleString(LOCALE, { style: 'currency', currency: 'EUR' }); }
  function qty(v, u) { if (u === 'kg' && v < 1) return fmt(v * 1000, 0) + ' g'; if (u === 'L' && v < 1) return fmt(v * 1000, 0) + ' mL'; return fmt(v, 2) + ' ' + u; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }

  /* Composition la moins chère couvrant le besoin (sac à dos non borné, pas de 0,1) */
  function cheapest(need, formats) {
    var avail = formats.filter(function (f) { return f.available; });
    if (!avail.length) avail = formats.slice();
    var S = 10, N = Math.ceil(need * S - 1e-9), maxS = 0;
    var items = avail.map(function (f) { var s = Math.round(f.size * S); if (s > maxS) maxS = s; return { f: f, s: s }; });
    var lim = N + maxS, INF = Infinity, cost = new Array(lim + 1).fill(INF), from = new Array(lim + 1).fill(-1);
    cost[0] = 0;
    for (var x = 1; x <= lim; x++) {
      for (var i = 0; i < items.length; i++) {
        var s = items[i].s;
        if (s <= x && cost[x - s] + items[i].f.price < cost[x]) { cost[x] = cost[x - s] + items[i].f.price; from[x] = i; }
      }
    }
    var best = -1;
    for (var y = N; y <= lim; y++) if (cost[y] < INF && (best < 0 || cost[y] < cost[best] || (cost[y] === cost[best] && y < best))) best = y;
    if (best < 0) return null;
    var count = {}, z = best;
    while (z > 0) { var k = from[z]; count[k] = (count[k] || 0) + 1; z -= items[k].s; }
    var lines = Object.keys(count).map(function (k) { return { f: items[k].f, qty: count[k] }; })
      .sort(function (a, b) { return b.f.size - a.f.size; });
    return { lines: lines, total: cost[best], got: best / S };
  }

  function addToCart(items, btn) {
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-loading') || '…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status && res.status >= 400) throw new Error(res.description || 'Erreur');
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }).catch(function (e) {
      btn.disabled = false; btn.textContent = btn.getAttribute('data-label');
      alertBox(btn, e.message);
    });
  }
  function alertBox(btn, msg) { var p = el('p', 'aqs-calc__error', msg); btn.parentNode.appendChild(p); setTimeout(function () { p.remove(); }, 6000); }

  function init(root) {
    var data = JSON.parse(root.querySelector('script[data-aqs-json]').textContent);
    var cfg = data.cfg, T = data.t, out = root.querySelector('[data-aqs-out]');
    var qInput = root.querySelector('[data-aqs-q]');
    var dims = root.querySelectorAll('[data-aqs-dim]');
    var shape = root.querySelector('[data-aqs-shape]');
    var dimOut = root.querySelector('[data-aqs-dimout]');

    function readQty() {
      if (cfg.type === 'liner') return null;
      var L = num(root.querySelector('[data-aqs-dim="l"]') && root.querySelector('[data-aqs-dim="l"]').value);
      var W = num(root.querySelector('[data-aqs-dim="w"]') && root.querySelector('[data-aqs-dim="w"]').value);
      var D = num(root.querySelector('[data-aqs-dim="d"]') && root.querySelector('[data-aqs-dim="d"]').value);
      var k = shape ? parseFloat(shape.value) : 1;
      if (L && W && (cfg.basis === 'surface' || D)) {
        var q = L * W * k * (cfg.basis === 'surface' ? 1 : D);
        q = Math.round(q * 10) / 10;
        if (dimOut) dimOut.textContent = T.estimated.replace('{q}', fmt(q)).replace('{u}', cfg.basis === 'surface' ? 'm²' : 'm³');
        if (qInput && document.activeElement !== qInput) qInput.value = String(q).replace('.', ',');
        return q;
      }
      if (dimOut) dimOut.textContent = '';
      return num(qInput && qInput.value);
    }
    function radioVal(name) { var r = root.querySelector('input[name="' + name + '"]:checked'); return r ? parseInt(r.value, 10) : 0; }

    function render() {
      out.innerHTML = '';
      if (cfg.type === 'dose') return renderDose(readQty());
      if (cfg.type === 'sizing') return renderSizing(readQty());
      if (cfg.type === 'liner') return renderLiner();
    }

    function contact(text) {
      var p = el('p', 'aqs-calc__help', (text ? text + ' ' : '') + T.help);
      out.appendChild(p);
    }

    function renderDose(q) {
      var unitQ = cfg.basis === 'surface' ? 'm²' : 'm³';
      if (!q) { out.appendChild(el('p', 'aqs-calc__placeholder', T.placeholder)); return; }
      if (cfg.max && q > cfg.max) { out.appendChild(el('p', 'aqs-calc__big', cfg.over_max || T.over)); contact(); return; }
      var lvl = cfg.levels[radioVal('aqs-level-' + data.pid)] || cfg.levels[0];
      var rate = 0;
      for (var i = 0; i < lvl.rates.length; i++) { var r = lvl.rates[i]; if (r[0] === null || q < r[0]) { rate = r[1]; break; } }
      var rep = cfg.repeat ? cfg.repeat[radioVal('aqs-rep-' + data.pid)] || cfg.repeat[0] : { n: 1 };
      var per = q * rate, need = per * rep.n;
      var box = el('div', 'aqs-calc__result');
      box.appendChild(el('p', 'aqs-calc__kicker', T.for_q.replace('{q}', fmt(q)).replace('{u}', unitQ) + ' · ' + lvl.label + (cfg.repeat ? ' · ' + rep.label : '')));
      var stats = el('div', 'aqs-calc__stats');
      stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + qty(per, cfg.unit) + '</strong><span>' + (cfg.dose_label || '') + '</span>'));
      if (rep.n > 1) stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + qty(need, cfg.unit) + '</strong><span>' + (rep.total_label || T.total) + '</span>'));
      stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + fmt(rate * (cfg.rate_factor || 1), 2) + ' ' + (cfg.rate_unit || '') + '</strong><span>' + (cfg.rate_label || T.rate) + '</span>'));
      box.appendChild(stats);
      var c = cheapest(need, data.formats);
      if (c) {
        var ul = el('ul', 'aqs-calc__lines');
        c.lines.forEach(function (l) {
          ul.appendChild(el('li', '', '<span>' + l.qty + ' × ' + l.f.label + (l.f.current ? ' <em>' + T.this_product + '</em>' : '') + '</span><span>' + eur(l.f.price * l.qty) + '</span>'));
        });
        box.appendChild(ul);
        box.appendChild(el('p', 'aqs-calc__total', '<span>' + T.total_price + '</span><strong>' + eur(c.total) + '</strong>'));
        if (data.formats.length === 1 && cfg.period_unit) {
          box.appendChild(el('p', 'aqs-calc__note', T.cover.replace('{g}', qty(c.got, cfg.unit)).replace('{n}', fmt(Math.floor(c.got / per + 1e-9), 0)).replace('{u}', cfg.period_unit)));
        } else if (data.formats.length > 1 && c.got - need > 0.05) {
          box.appendChild(el('p', 'aqs-calc__note', T.margin.replace('{g}', qty(c.got, cfg.unit)).replace('{m}', qty(c.got - need, cfg.unit))));
        }
        var btn = el('button', 'button button--primary aqs-calc__add', T.add);
        btn.type = 'button'; btn.setAttribute('data-label', T.add); btn.setAttribute('data-loading', T.adding);
        btn.addEventListener('click', function () { addToCart(c.lines.map(function (l) { return { id: l.f.id, quantity: l.qty }; }), btn); });
        box.appendChild(btn);
      }
      out.appendChild(box);
      if (cfg.note) out.appendChild(el('p', 'aqs-calc__note', cfg.note));
      contact();
    }

    function renderSizing(q) {
      if (!q) { out.appendChild(el('p', 'aqs-calc__placeholder', T.placeholder)); return; }
      var models = data.models, fit = null, cur = null;
      models.forEach(function (m) { if (m.current && !cur) cur = m; if (!fit && q >= m.min && q <= m.max) fit = m; });
      var sameProduct = models.every(function (m) { return m.current; });
      if (sameProduct) cur = null;
      var U = cfg.basis === 'surface' ? 'm²' : 'm³';
      var box = el('div', 'aqs-calc__result');
      box.appendChild(el('p', 'aqs-calc__kicker', T.for_q.replace('{q}', fmt(q)).replace('{u}', U)));
      if (!fit) {
        var maxM = models[models.length - 1];
        if (q > maxM.max) { box.appendChild(el('p', 'aqs-calc__big', cfg.over_max || T.over)); out.appendChild(box); contact(); return; }
        fit = models[0];
      }
      if (cur && fit.id === cur.id) {
        box.appendChild(el('p', 'aqs-calc__ok', T.fits.replace('{n}', cur.name).replace('{r}', fmt(cur.min, 0) + '–' + fmt(cur.max, 0) + ' ' + U)));
      } else {
        box.appendChild(el('p', cur ? 'aqs-calc__warn' : 'aqs-calc__ok', cur ? T.not_fit.replace('{n}', cur.name).replace('{r}', fmt(cur.min, 0) + '–' + fmt(cur.max, 0) + ' ' + U) : T.advise));
        var card = el('div', 'aqs-calc__model');
        card.innerHTML = (fit.img ? '<img src="' + fit.img + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<div><p class="aqs-calc__model-name"><a href="' + fit.url + '">' + (sameProduct ? fit.name : fit.title) + '</a></p><p>' + T.range.replace('{r}', fmt(fit.min, 0) + '–' + fmt(fit.max, 0) + ' ' + U) + ' · <strong>' + eur(fit.price) + '</strong></p></div>';
        box.appendChild(card);
        if (fit.multi) {
          var a = el('a', 'button button--primary aqs-calc__add', T.see_model);
          a.href = fit.url; box.appendChild(a);
        } else if (fit.available) {
          var btn = el('button', 'button button--primary aqs-calc__add', T.add_model);
          btn.type = 'button'; btn.setAttribute('data-label', T.add_model); btn.setAttribute('data-loading', T.adding);
          btn.addEventListener('click', function () { addToCart([{ id: fit.id, quantity: 1 }], btn); });
          box.appendChild(btn);
        }
      }
      out.appendChild(box);
      if (cfg.note) out.appendChild(el('p', 'aqs-calc__note', cfg.note));
      contact();
    }

    function renderLiner() {
      var L = num(root.querySelector('[data-aqs-dim="l"]').value);
      var W = num(root.querySelector('[data-aqs-dim="w"]').value);
      var D = num(root.querySelector('[data-aqs-dim="d"]').value);
      if (!L || !W || !D) { out.appendChild(el('p', 'aqs-calc__placeholder', T.placeholder_liner)); return; }
      var m = cfg.margin === undefined ? 0.5 : cfg.margin;
      var a = L + 2 * D + 2 * m, b = W + 2 * D + 2 * m;
      a = Math.ceil(a * 10) / 10; b = Math.ceil(b * 10) / 10;
      var small = Math.min(a, b), big = Math.max(a, b);
      if (cfg.area_only) {
        var ar = Math.ceil(a * b), v0 = data.widths[0];
        var bx = el('div', 'aqs-calc__result');
        bx.appendChild(el('p', 'aqs-calc__kicker', T.liner_for.replace('{l}', fmt(L, 2)).replace('{w}', fmt(W, 2)).replace('{d}', fmt(D, 2))));
        var st = el('div', 'aqs-calc__stats');
        st.appendChild(el('div', 'aqs-calc__stat', '<strong>' + fmt(big, 2) + ' × ' + fmt(small, 2) + ' m</strong><span>' + T.liner_dims + '</span>'));
        st.appendChild(el('div', 'aqs-calc__stat', '<strong>' + ar + ' m²</strong><span>' + T.liner_qty + '</span>'));
        bx.appendChild(st);
        bx.appendChild(el('p', 'aqs-calc__total', '<span>' + T.total_price + '</span><strong>' + eur(v0.price * ar) + '</strong>'));
        if (v0.available) { var b2 = el('button', 'button button--primary aqs-calc__add', T.add); b2.type = 'button'; b2.setAttribute('data-label', T.add); b2.setAttribute('data-loading', T.adding); b2.addEventListener('click', function () { addToCart([{ id: v0.id, quantity: ar }], b2); }); bx.appendChild(b2); }
        out.appendChild(bx); if (cfg.note) out.appendChild(el('p', 'aqs-calc__note', cfg.note)); contact(); return;
      }
      var widths = data.widths.slice().sort(function (x, y) { return x.w - y.w; });
      var pick = null;
      for (var i = 0; i < widths.length; i++) if (widths[i].w >= small) { pick = widths[i]; break; }
      var box = el('div', 'aqs-calc__result');
      box.appendChild(el('p', 'aqs-calc__kicker', T.liner_for.replace('{l}', fmt(L, 2)).replace('{w}', fmt(W, 2)).replace('{d}', fmt(D, 2))));
      var stats = el('div', 'aqs-calc__stats');
      stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + fmt(big, 2) + ' × ' + fmt(small, 2) + ' m</strong><span>' + T.liner_dims + '</span>'));
      if (pick) {
        var area = Math.ceil(pick.w * big);
        stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + fmt(pick.w, 2) + ' m</strong><span>' + T.liner_width + '</span>'));
        stats.appendChild(el('div', 'aqs-calc__stat', '<strong>' + area + ' m²</strong><span>' + T.liner_qty + '</span>'));
        box.appendChild(stats);
        box.appendChild(el('p', 'aqs-calc__note', T.liner_explain.replace('{w}', fmt(pick.w, 2)).replace('{b}', fmt(big, 2)).replace('{a}', area)));
        box.appendChild(el('p', 'aqs-calc__total', '<span>' + T.total_price + '</span><strong>' + eur(pick.price * area) + '</strong>'));
        if (pick.available) {
          var btn = el('button', 'button button--primary aqs-calc__add', T.add);
          btn.type = 'button'; btn.setAttribute('data-label', T.add); btn.setAttribute('data-loading', T.adding);
          btn.addEventListener('click', function () { addToCart([{ id: pick.id, quantity: area }], btn); });
          box.appendChild(btn);
        }
      } else {
        box.appendChild(stats);
        box.appendChild(el('p', 'aqs-calc__big', T.liner_over));
      }
      out.appendChild(box);
      if (cfg.note) out.appendChild(el('p', 'aqs-calc__note', cfg.note));
      contact();
    }

    root.addEventListener('input', render);
    root.addEventListener('change', render);
    render();
  }

  function boot() { document.querySelectorAll('[data-aqs-calc]').forEach(function (r) { if (!r.__aqs) { r.__aqs = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  if (window.MutationObserver) new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
